import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { mapProjectProfileToUi } from "../mapToUi";
import { getUserRoles } from "../../auth/slice";
import { userRoles } from "../../../constants/userRoles";
import SupplyChainProjectProfile from "./SupplyChain";
import DeactivateModal from "./deactivateModal";
import SupplierProfile from "./suppliers";
import SalesProfile from "./sales";
import { getProjectById } from "../api";
import trackAnalytics from "../../../trackAnalytics";
import { setMessage } from "../../shared/notification/slice";
import FinanceProfile from "./financeProfile";
import OperationsProfile from "./operations";
import PricingProfile from "./pricingProfile";

export default function ProjectProfile() {
    const [projectId, setProjectId] = useState("");
    const [clientProject, setClientProject] = useState(null);
    const location = useLocation();
    const [isCurrentUserSales, setIsCurrentUserSales] = useState(false);
    const [isCurrentUserSupplier, setIsCurrentUserSupplier] = useState(false);
    const [isCurrentUserProjectManager, setIsCurrentUserProjectManager] = useState(false);
    const [isCurrentUserFinance, setIsCurrentUserFinance] = useState(false);
    const [isCurrentUserOperations, setIsCurrentUserOperations] = useState(false);
    const [isCurrentUserPricing, setIsCurrentUserPricing] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [organizationId, setOrganizationId] = useState("");
    const [monthlyProjectId, setMonthlyProjectId] = useState("");
    const [conditionId, setConditionId] = useState("");
    const [penaltiesAndDeductions, setPenaltiesAndDeductions] = useState({});
    const [allIllaDeductions, setAllIllaDeductions] = useState([]);
    const [allClientDeductions, setAllClientDeductions] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsCurrentUserSales(
            getCurrentUserRoles.some(
                (role) =>
                    role === userRoles.ACCOUNT_MANAGER || role === userRoles.SALES_REPRESENTATIVE
            )
        );
        setIsCurrentUserSupplier(
            getCurrentUserRoles.some((role) => role === userRoles.SUPPLY_REPRESENTATIVE)
        );

        setIsCurrentUserProjectManager(
            getCurrentUserRoles.some(
                (role) => role === userRoles.PROJECT_MANAGER || role === userRoles.SUPERADMIN
            )
        );
        setIsCurrentUserFinance(
            getCurrentUserRoles.some((role) => role === userRoles.FINANCE_SPECIALIST)
        );
        setIsCurrentUserOperations(
            getCurrentUserRoles.some((role) => role === userRoles.OPERATIONS_REPRESENTATIVE)
        );
        setIsCurrentUserPricing(
            getCurrentUserRoles.some((role) => role === userRoles.PRICING_SPECIALIST)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (location?.state?.projectId) {
            setProjectId(location?.state?.projectId);
            setOrganizationId(location?.state?.OrganizationId);
        } else {
            setProjectId(location?.pathname?.split("/")[2]);
        }
    }, [location]);

    useEffect(() => {
        if (isCurrentUserSales) {
            setConditionId(clientProject?.salesConditionsId[0]);
        }
        trackAnalytics(location.pathname, { ProjectStatus: clientProject?.status });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientProject]);
    const ProjectData = async () => {
        const data = await getProjectById(projectId);
        if (data) {
            setClientProject(
                mapProjectProfileToUi(
                    _.values(data?.entities["projects"]),
                    _.values(data?.entities["organizations"]),
                    _.values(data?.entities["attachments"]),
                    _.values(data?.entities["standardsAndOperationalProcedures"]),
                    _.values(data?.entities["projectPenaltiesAndDeductions"]),
                    _.values(data?.entities["penaltiesAndDeductions"])
                )
            );
            setOrganizationId(_.values(data?.entities["organizations"])[0]?.id);
            setMonthlyProjectId(
                _.values(data?.entities["projects"])[0]["attributes"]?.projectableId
            );
        } else {
            dispatch(
                setMessage({
                    content: ``,
                    title: `the project could not be found`,
                    isError: true,
                })
            );
        }
    };

    useEffect(() => {
        if (projectId !== "") ProjectData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId]);

    return (
        <>
            {isCurrentUserSales && (
                <SalesProfile
                    clientProjectData={clientProject}
                    projectId={projectId}
                    organizationId={organizationId}
                    monthlyProjectId={monthlyProjectId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                />
            )}
            {isCurrentUserSupplier && clientProject !== null && (
                <SupplierProfile
                    clientProject={clientProject}
                    projectId={projectId}
                    organizationId={organizationId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                />
            )}
            {isCurrentUserProjectManager && (
                <SupplyChainProjectProfile
                    clientProject={clientProject}
                    projectId={projectId}
                    organizationId={organizationId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                />
            )}
            {isCurrentUserFinance && (
                <FinanceProfile
                    clientProject={clientProject}
                    projectId={projectId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                />
            )}
            {isCurrentUserPricing && (
                <PricingProfile
                    clientProject={clientProject}
                    projectId={projectId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                    organizationId={organizationId}
                />
            )}
            {isCurrentUserOperations && (
                <OperationsProfile
                    clientProject={clientProject}
                    projectId={projectId}
                    organizationId={organizationId}
                    setAllIllaDeductions={setAllIllaDeductions}
                    setAllClientDeductions={setAllClientDeductions}
                    allIllaDeductions={allIllaDeductions}
                    allClientDeductions={allClientDeductions}
                    penaltiesAndDeductions={penaltiesAndDeductions}
                    setPenaltiesAndDeductions={setPenaltiesAndDeductions}
                />
            )}
            <DeactivateModal
                isShow={showDeactivateModal}
                activeWorkingCondition
                conditionId={conditionId}
                onHide={() => {
                    setShowDeactivateModal(false);
                }}
                role={userRoles.SALES_REPRESENTATIVE}
            />
        </>
    );
}
